import { isNativeApp } from '@/utils/deviceUtils';

const MOBILE_MESSAGES_NAME = {
  PAGE_MOUNTED: 'pageMounted',
  LOGOUT: 'logout',
  SHARE_IMAGE: 'shareImage',
  SHARE_LINK: 'shareLink',
  DOWNLOAD_IMAGE: 'downloadImage',
  DOWNLOAD_CSV: 'downloadCsv',
  IN_APP_SUBSCRIPTION: 'inAppSubscription',
  CANCEL_SUBSCRIPTION: 'cancelSubscription',
};

const INCOME_MOBILE_MESSAGES_NAME = {
  SUBSCRIPTION_PURCHASE_RESULT: 'subscriptionPurchaseResult',
};

function dispatchMessageToMobile(name, detail) {
  if (isNativeApp()) {
    window.dispatchEvent(new CustomEvent(
      name,
      { detail },
    ));
  }
}

function addListenerToMobileMessage(name, onResult) {
  window.addEventListener(name, e => {
    onResult(e.detail);
  });
}

export default { dispatchMessageToMobile, addListenerToMobileMessage, MOBILE_MESSAGES_NAME, INCOME_MOBILE_MESSAGES_NAME };
